import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { ProductDTO } from '../../services/product.service';

@Component({
  selector: 'app-product-read',
  templateUrl: './product-read.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TagModule]
})
export class ProductReadComponent {
  product = input.required<ProductDTO>();

  applicationTypeLabel(type?: string): string {
    switch (String(type || '').toUpperCase()) {
      case 'TAXABLE':
        return 'Gravado';
      case 'EXEMPT':
        return 'Exento';
      case 'ZERO_RATED':
        return 'Tasa 0';
      default:
        return '';
    }
  }

  collectionTypeLabel(type?: string): string {
    switch (String(type || '').toUpperCase()) {
      case 'SELLER_COLLECTS':
        return 'Traslado';
      case 'SELLER_WITHHOLDS':
        return 'Retención';
      default:
        return '';
    }
  }
}
